<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["login"] }}</p>
      </div>
      <p class="content_title" v-if="!config.privateSignUp">
        {{ this.$store.getters.TRANSLATIONS["enter_credentials"] }}
      </p>
      <p
        class="content_title"
        v-if="config.privateSignUp && !showCodeVerification"
      >
        {{ this.$store.getters.TRANSLATIONS["enter_phone_number"] }}
      </p>
      <p
        class="content_title"
        v-if="config.privateSignUp && showCodeVerification"
      >
        {{ this.$store.getters.TRANSLATIONS["enter_code_from_sms"] }}
      </p>
      <input
        type="text"
        v-model="email"
        :placeholder="this.$store.getters.TRANSLATIONS['email']"
        class="email"
        autocomplete="off"
        v-if="!config.privateSignUp"
      />
      <input
        type="password"
        v-model="password"
        :placeholder="this.$store.getters.TRANSLATIONS['password']"
        class="password"
        autocomplete="off"
        v-if="!config.privateSignUp"
      />
      <p
        class="forgot_password"
        v-on:click="forgotPassword()"
        v-if="!config.privateSignUp"
      >
        {{ this.$store.getters.TRANSLATIONS["forgot_password"] }}
      </p>
      <!-- <input
        type="tel"
        v-mask="['+1 (###) ###-####']"
        v-model="telephone"
        placeholder="Phone"
        class="phone"
        autocomplete="off"
      />-->
      <input
        type="tel"
        v-model="telephone"
        :placeholder="this.$store.getters.TRANSLATIONS['phone']"
        class="phone"
        autocomplete="off"
        v-if="config.privateSignUp && !showCodeVerification"
      />

      <input
        type="tel"
        v-model="code"
        :placeholder="this.$store.getters.TRANSLATIONS['code']"
        class="code"
        autocomplete="off"
        v-if="config.privateSignUp && showCodeInput"
      />
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="back()" class="button back_button">
        {{ this.$store.getters.TRANSLATIONS["back"] }}
      </button>
      <button v-on:click="login()" class="button" v-if="!config.privateSignUp">
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
      <button
        v-on:click="privateLogin()"
        class="button"
        v-if="config.privateSignUp && !showCodeVerification"
      >
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
      <button
        v-on:click="privateLoginFinal()"
        class="button"
        v-if="config.privateSignUp && showCodeVerification"
      >
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
  </div>
</template>

<script>
export default {
  created() {
    if (this.$storage.get("parkendaToken")) {
      const timeout = setTimeout(() => {
        this.loading = true;
      }, 0);
      this.$http
        .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
          headers: {
            "x-access-token": this.$storage.get("parkendaToken")
          }
        })
        .then((response) => {
          this.$store.dispatch("SAVE_USER", response.data);
          this.$store.dispatch(
            "SAVE_TOKEN",
            this.$storage.get("parkendaToken")
          );
        })
        .then(() => {
          return this.$http
            .get(`${process.env.SERVER_URL}/FA04C1C44AFA43CF9170E1D70335412B`, {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            })

            .then((response) => {
              console.log("Have active parking response");
              console.log(response);
              if (response.data && response.data.haveActiveParking) {
                this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", true);
                this.$router.push("currentParking");
              } else {
                this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", false);
                this.$router.push("parkendaValet");
              }
            });
        })
        .catch((e) => {
          this.$storage.remove("parkendaToken");
        })
        .finally(() => {
          clearTimeout(timeout);
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      cssDialog: {
        color: "red",
        "background-color": "green"
      },
      loading: true,
      showCodeInput: false,
      showCodeVerification: false,
      email: "",
      password: "",
      telephone: "",
      code: "",
      forgotPassword: () => {
        this.$router.push("/forgotPassword");
      },
      login: (privateEmail, privatePassword) => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/64C356004C364F31931226C419FBE7B7`, {
            email: privateEmail ? privateEmail : this.email,
            password: privatePassword ? privatePassword : this.password
          })
          .then((response) => {
            console.log("Login response");
            console.log(response);
            this.$store.dispatch("SAVE_TOKEN", response.data.authToken);
            this.$storage.set("parkendaToken", response.data.authToken);
          })
          .then(() => {
            return this.$http
              .get(
                `${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`,
                {
                  headers: {
                    "x-access-token": this.$storage.get("parkendaToken")
                  }
                }
              )
              .then((response) => {
                console.log("Get current user response:");
                console.log(response);
                if (response.data) {
                  this.customerId = response.data.id;
                  this.$store.dispatch("SAVE_USER", response.data);
                }
              });
          })
          .then(() => {
            return this.$http
              .get(
                `${process.env.SERVER_URL}/4FB40BC809DA4F86BC3189262DCAFFB7/${this.customerId}`,
                {
                  headers: {
                    "x-access-token": this.$storage.get("parkendaToken")
                  }
                }
              )
              .then((response) => {
                console.log("Get residents for current customer response:");
                console.log(response);
                if (response.data) {
                  this.$store.dispatch(
                    "SAVE_CUSTOMER_HAS_RESIDENTS",
                    response.data
                  );
                }
              });
          })
          .then(() => {
            return this.$http
              .get(
                `${process.env.SERVER_URL}/FA04C1C44AFA43CF9170E1D70335412B`,
                {
                  headers: {
                    "x-access-token": this.$storage.get("parkendaToken")
                  }
                }
              )
              .then((response) => {
                console.log("Have active parking response");
                console.log(response);
                if (response.data && response.data.haveActiveParking) {
                  this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", true);
                  this.$router.push("/currentParking");
                } else {
                  this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", false);
                  this.$router.push("/parkendaValet");
                }
              });
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK"
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      privateLoginFinal() {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/8360C67E2CA54E909E396F31F6D35B3D`, {
            telephone: this.telephone,
            code: this.code
          })
          .then((response) => {
            this.loading = false;
            if (response.data) {
              const email = response.data.email;
              const password = response.data.telephone;
              this.login(email, password);
            } else {
              throw "Please enter a valid code";
            }
          })
          .catch((error) => {
            let text =
              this.$store.getters.TRANSLATIONS["please_enter_a_valid code"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK"
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      privateLogin() {
        this.code = "";
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(`${process.env.SERVER_URL}/A0BB002DEC7948F399455523DD49A08F`, {
            telephone: this.telephone
          })
          .then((response) => {
            this.loading = false;
            console.log(response);
            if (
              response.data &&
              response.data.code &&
              response.data.code === "Sent"
            ) {
              this.showCodeInput = true;
              this.showCodeVerification = true;
            } else {
              throw "Can't send SMS code! Check your internet connection";
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["wrong_phone"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK"
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        if (this.config.privateSignUp && this.showCodeVerification) {
          this.showCodeVerification = false;
          this.showCodeInput = false;
        } else {
          this.$router.push("/");
        }
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
input {
  margin: 5vh 17vw 0px;
  width: 65%;
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
input::placeholder {
  color: rgba(114, 174, 255, 1);
}
.text {
  color: #fbae31;
  font-size: 3.5vh;
  font-family: BrandonGrotesqueMedium;
  text-align: left;
  margin-left: 17vw;
  text-decoration: underline;
  text-decoration-color: gray;
  line-height: 0.5;
  text-underline-offset: 10px;
}
.content_title {
  color: #ffffff;
  margin-top: 3.5vh;
  font-size: 1.6vh;
  font-family: BrandonGrotesqueMedium;
  text-align: left;
  margin-left: 17vw;
}
.back_button {
  background-color: white;
  color: #fbae31;
}
.next_button:disabled {
  display: none;
}
.button {
  font-size: 2vh;
}
.forgot_password {
  font-size: 4vw;
  text-align: center;
  margin: 4vh 0px;
  font-weight: 600;
  letter-spacing: 0.5vw;
  cursor: pointer;
}
.modal-css {
  color: "red";
  background-color: aqua;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue